import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TransferirPix } from '../../../store/pagamento/actions/pagamentoAction';
import { GetCarteiraBase } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { TransferenciaPixRequest, PagamentoPixResponse } from 'domain/types/_carteira/premiacao/transferenciaPixTypes';
import { UnknownAction } from '@reduxjs/toolkit';

export function useTransferencia() {
  const dispatch = useDispatch();

  const transferirPix = useCallback(function transferirPixCallback(
    carteiraId: number, 
    request: TransferenciaPixRequest, 
    // eslint-disable-next-line no-unused-vars
    callback: (success: boolean, response?: PagamentoPixResponse) => void
  ) {
    dispatch(TransferirPix(carteiraId, request, callback) as unknown as UnknownAction);
  }, [dispatch]);

  const getCarteiraBase = useCallback(function getCarteiraBaseCallback(carteiraId: number) {
    dispatch(GetCarteiraBase(carteiraId) as unknown as UnknownAction);
  }, [dispatch]);

  return {
    transferirPix,
    getCarteiraBase
  }
}
